/**
 * Parses the public Kuali identifiers accepted by the connector UI.
 *
 * Users may paste identifiers or replace them with the first column of a CSV.
 * This module only extracts user-visible values; the backend remains
 * responsible for resolving Kuali internal IDs, relationships, and active
 * sequences.
 */
export const KUALI_RESEARCH_SANDBOX_API_URL = 'https://usmd-sbx.kuali.co/res'
export const KUALI_RESEARCH_DEFAULT_MODULE_LIMIT = 1500

export function parseAwardNumbers(value: string): string[] {
  const matches = value.match(/\b\d{6}-\d{5}\b/g) ?? []
  return [...new Set(matches)]
}

export function parseNumericIdentifiers(value: string): string[] {
  return [...new Set(value.match(/\b\d{1,22}\b/g) ?? [])]
}

export function parseKualiCsvFirstColumn(value: string): string[] {
  return value
    .replace(/^\uFEFF/, '')
    .split(/\r?\n/)
    .filter(row => row.trim())
    .map(row => firstCell(row).trim())
    .filter(Boolean)
}

function firstCell(row: string): string {
  if (!row.startsWith('"')) return row.split(',', 1)[0]
  let value = ''
  for (let index = 1; index < row.length; index += 1) {
    if (row[index] !== '"') {
      value += row[index]
      continue
    }
    if (row[index + 1] === '"') {
      value += '"'
      index += 1
      continue
    }
    return value
  }
  throw new Error('Kuali CSV contains an unterminated quoted value')
}
